module.exports = __webpack_public_path__ + "static/SW1-1201e72db5c68339b5cef11009b43c3a.jpg";